<template>
  <div>
    <div class="content-header">
      <div class="left">
        员工列表
        <Alert
          type="warning"
          show-icon
          style="margin: 0 0 0 10px"
          v-if="shop_agent.staff - page.total <= 5"
          >仅剩{{ shop_agent.staff - page.total }}个子账号名额，<router-link
            :to="{ name: 'OperationPeriod_buy' }"
            >获取更多名额 ></router-link
          ></Alert
        >
      </div>
      <div class="right">
        <Button
          icon="md-add"
          type="primary"
          @click="EDIT(false)"
          v-if="
            $CheckShow($route.name, 'staff_add') &&
            shop_agent.staff - page.total > 0
          "
          >新增员工</Button
        >
      </div>
      <div class="bottom">
        <Input
          v-model="page.search"
          style="width: 280px"
          maxlength="11"
          show-word-limit
          placeholder="根据条件搜索"
        >
          <Select
            v-model="page.searchKey"
            slot="prepend"
            style="width: 120px; color: black"
          >
            <Option value="tel">用户名/手机号</Option>
            <Option value="name">姓名</Option>
          </Select>
        </Input>
        <Select v-model="page.role_id" style="width: 200px; margin-left: 10px">
          <Option v-for="item in role" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
        <Button
          type="primary"
          style="margin-left: 10px"
          icon="ios-search"
          @click="getStaffList"
          >搜索</Button
        >
        <Button
          style="margin-left: 10px"
          @click="
            () => {
              this.page.search = '';
              this.page.role_id = 0;
              this.p = 0;
              this.getStaffList();
            }
          "
          >重置</Button
        >
      </div>
    </div>
    <Table :columns="columns" :data="data">
      <template slot-scope="{ row }" slot="action" fixed="right">
        <Button
          type="success"
          size="small"
          @click="regCustomerService(row.id)"
          v-if="$CheckShow($route.name, 'staff_edit') && !row.im_id"
          >设为客服</Button
        >
        <Button
          type="primary"
          size="small"
          @click="EDIT(row)"
          v-if="
            $CheckShow($route.name, 'staff_edit') &&
            row.role_name !== '超级管理员'
          "
          style="margin-left: 5px"
          >编辑</Button
        >
        <Button
          :type="row.status ? 'warning' : 'error'"
          size="small"
          @click="disableStaff(row)"
          style="margin-left: 5px"
          v-if="
            $CheckShow($route.name, 'staff_edit') &&
            row.role_name !== '超级管理员'
          "
          >{{ row.status ? "启用" : "禁用" }}</Button
        >
      </template>
    </Table>
    <div class="t-right t-top-10">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="page.total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
    <Modal
      title="新增/编辑"
      v-model="modal.status"
      width="800"
      class-name="vertical-center-modal"
      @on-ok="save"
      @on-cancel="cancelModal"
    >
      <div>
        <Form
          ref="formInline"
          :model="info"
          :rules="rule"
          :label-width="100"
          inline
        >
          <FormItem prop="name" label="员工姓名:">
            <Input
              v-model="info.name"
              style="width: 260px"
              placeholder="请输入员工姓名"
            />
          </FormItem>
          <br />
          <FormItem prop="tel" label="员工账号:">
            <Input
              v-model="info.tel"
              style="width: 260px"
              placeholder="请输入手机号码"
              :disabled="isEdite"
            />
            <div style="margin-top: 15px" v-if="!isEdite">
              <Input
                v-model="info.code"
                style="width: 160px; margin-right: 15px;"
                placeholder="请输入短信验证码"
              />
              <span @click="getSmsRequest" style="cursor: pointer;">{{verifiy.verifiyBtnText }}</span>
            </div>
          </FormItem>

          <br />
          <FormItem prop="role_id" label="角色:">
            <Select
              v-model="info.role_id"
              style="width: 260px"
              @on-change="handelRole"
            >
              <Option v-for="item in role" :value="item.id" :key="item.id">{{
                item.name
              }}</Option>
              <!-- v-if="item.name !== '超级管理员'" -->
            </Select>
            <div
              v-if="info.role_name === '超级管理员' && !info.admin_role_id"
              class="describe"
            >
              请为之前的超级管理员配置新角色
            </div>
          </FormItem>
          <FormItem
            v-if="info.role_name === '超级管理员'"
            prop="admin_role_id"
            label="超级管理员:"
          >
            <Select
              v-model="info.admin_role_id"
              style="width: 260px"
              placeholder="指定新角色"
            >
              <Option
                v-for="item in role"
                :value="item.id"
                v-if="item.name != '超级管理员'"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <br />
          <FormItem label>
            <Checkbox v-model="info.checked" label>
              <span style="font-size: 12px"
                >是否重置密码（密码将重置为:123456）</span
              >
            </Checkbox>
          </FormItem>
          <br />
        </Form>
      </div>
      <div slot="footer">
        <Button type="default" size="default" @click="modal.status = false"
          >取消</Button
        >
        <Button
          type="primary"
          size="default"
          :loading="modal.loading"
          @click="save"
          >保存</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const CheckMobile = (rule, tel, callback) => {
  if (!tel) {
    return callback(new Error("请输入手机号码"));
  }
  const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
  if (!myreg.test(tel)) {
    return callback(new Error("手机号码错误"));
  } else {
    return callback();
  }
};
export default {
  data() {
    return {
      columns: [
        // {
        //   title: "编号",
        //   key: "id",
        //   width: 100,
        // },
        {
          title: "员工账号",
          key: "tel",
        },
        {
          title: "员工姓名",
          key: "name",
        },
        {
          title: "员工角色",
          key: "role_name",
        },
        {
          title: "操作",
          slot: "action",
          width: 210,
        },
      ],
      data: [],
      page: {
        p: 0,
        l: 10,
        search: "",
        searchKey: "tel",
        role_id: "",
        total: 0,
      },
      role: [],
      modal: {
        status: false,
        loading: false,
      },
      rule: {
        name: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
        tel: [{ required: true, validator: CheckMobile, trigger: "blur" }],
        role_id: [{ required: true, message: "请选择角色", trigger: "change" }],
      },
      info: {
        id: 0,
        name: "",
        tel: "",
        role_id: "",
        checked: true,
        role_name: "",
        admin_role_id: 0,
      },
      isEdite: false,
      shopInfo: {},
      verifiy: {
        img: "",
        verifiyBtnText: "获取验证码",
        verifiyTime: 0,
        timer: null,
      },
    };
  },
  methods: {
    ...mapActions([
      "GetRoleList",
      "GetStaffList",
      "StaffSave",
      "RegCustomerService",
      "GetShopInfo",
      "GetSms",
    ]),
    getRoleList() {
      this.GetRoleList().then((res) => {
        res.data.map((item) => {
          item.id = item.id + "";
        });
        this.role = res.data;
      });
    },
    getStaffList() {
      let data = {};
      data.l = this.page.l;
      data.p = this.page.p;
      if (this.page.searchKey && this.page.search)
        data[this.page.searchKey] = this.page.search;
      if (this.page.role_id) data.role_id = this.page.role_id;

      this.$PushParams(this.$route.name, this.page);
      this.GetStaffList(data).then((res) => {
        this.data = res.data;
        this.page.total = res.total;
      });
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getStaffList();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    EDIT(row) {
      console.log("row", row);
      if (!row) {
        if(this.role.length==1){
          this.$Message.error("请先添加员工角色!");
          return;
        }
        this.isEdite = false;
        this.info = {
          id: 0,
          user_id: 0,
          name: "",
          tel: "",
          role_id: "",
          checked: true,
          status: 0,
          role_name: "",
          admin_role_id: 0,
        };
      } else {
        this.isEdite = true;
        this.info = {
          id: row.id,
          user_id: row.user_id,
          name: row.name,
          tel: row.tel + "",
          role_id: row.role_id + "",
          checked: false,
          status: row.status,
          role_name: row.role_name,
          admin_role_id: 0,
        };
      }

      this.modal.status = true;
    },
    save() {
      let params = {
        id: this.info.id,
        name: this.info.name,
        role_id: this.info.role_id,
        tel: this.info.tel,
        is_reset: this.info.checked ? 1 : 0,
        status: this.info.status,
        admin_role_id: this.info.admin_role_id,
        code: this.info.code,
      };
      let admin_role_id = 0;
      this.role.map((item) => {
        if (item.name === "超级管理员") admin_role_id = item.id;
      });
      if (admin_role_id === params.role_id && !params.admin_role_id) {
        this.$Message.error("请为之前的超级管理员配置新角色");
        return false;
      }
      if (this.info.user_id) params.user_id = this.info.user_id;
      console.log("save", params);
      this.$refs.formInline.validate((valid) => {
        console.log("valid", valid);
        if (valid) {
          if(admin_role_id === params.role_id){
               this.$Modal.confirm({
               title: "提醒",
               content:
                  "你正在修改店铺的超级管理员，确认后你的角色将发生变化，并将使用新角色的权限，是否确认修改？",
                width: 560,
                okText: "确定",
                onCancel: () => {},
                onOk: () => {
                    this.modal.loading = true;
                    this.StaffSave(params).then((res) => {
                      this.modal.loading = false;
                      if (res.status) {
                        this.modal.status = false;
                        this.$Message.success(res.msg);
                        window.onload();
                        return false;
                      } else {
                        this.$Message.error(res.msg);
                      }
                    });
                },
              });
          }else{
            this.modal.loading = true;
            this.StaffSave(params).then((res) => {
              this.modal.loading = false;
              if (res.status) {
                this.modal.status = false;
                this.$Message.success(res.msg);
                this.getStaffList();
                return false;
              } else {
                this.$Message.error(res.msg);
              }
            });
          }
        }
      });
    },
    regCustomerService(id) {
      this.RegCustomerService({ id }).then((res) => {
        if (!res.status) {
          this.$Message.error(res.msg);
        }
        this.$Message.success(res.msg);
        this.getStaffList();
      });
    },
    disableStaff(row) {
      console.log("禁用", row);
      const params = {
        id: row.id,
        user_id: row.user_id,
        name: row.name,
        tel: row.tel,
        role_id: row.role_id,
        checked: false,
        status: row.status ? 0 : 1,
      };
      this.StaffSave(params).then((res) => {
        this.$Message[res.status ? 'success' : 'error'](res.msg);
        if(res.status) this.getStaffList();
      });
    },
    //获取短信验证码
    getSmsRequest() {
      if (this.verifiy.time) return false;
      this.GetSms({ shop_id: this.shopInfo.id, tel: this.info.tel }).then(
        (res) => {
          if (!res.status) {
            this.$Message.error(res.msg);
          } else {
            this.$Message.success(res.msg);

            this.verifiy.time = 60;
            this.verifiy.timer = setInterval(() => {
            if (this.verifiy.time) {
              this.verifiy.time--;
              this.verifiy.verifiyBtnText = `${this.verifiy.time}S`;
            } else {
              this.verifiy.time = 0;
              this.verifiy.verifiyBtnText = `获取验证码`;
              clearInterval(this.verifiy.timer);
            }
          }, 1000);
          }
        }
      );
    },
    handelRole(e) {
      this.role.map((item) => {
        if (item.id == e) {
          this.info.role_name = item.name;
        }
      });
    },
    cancelModal(){
       clearInterval(this.verifiy.timer);
    }
  },
  created() {
    let params = this.$GetParams(this.$route.name);
    for (let k in params) {
      if (params[k]) this.page[k] = params[k];
    }
    this.getRoleList();
  },
  mounted() {
    this.GetShopInfo().then((res) => {
      if (res.status) {
        this.shopInfo = res.data;
      }
    });
    this.getStaffList();
  },
  computed: mapGetters({
    shop_agent: "shop_agent",
    current_user: "current_user",
  }),
};
</script>

<style lang="less" scoped>
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
.describe {
  font-size: 12px;
  color: red;
  height: 20px;
}
</style>
